import store from "@frameworks/web/redux/store";
import { CLIENT_FORGOT_USERID, CLIENT_FORGOT_USERID_ERROR, CLIENT_FORGOT_USERID_HIDE_ERROR, CLIENT_FORGOT_USERID_START_LOADER, CLIENT_FORGOT_USERID_STOP_LOADER, } from "../interface/IClientForgotUserID";
class ClientForgotUserIDActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    forgotUserID(data) {
        this.dispatch({
            type: CLIENT_FORGOT_USERID,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: CLIENT_FORGOT_USERID_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: CLIENT_FORGOT_USERID_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: CLIENT_FORGOT_USERID_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: CLIENT_FORGOT_USERID_STOP_LOADER,
        });
    }
}
export default ClientForgotUserIDActions;
